export default "__VITE_PUBLIC_ASSET__9e51689f__"